export default __webpack_public_path__ + "static/media/medium.dc77d863.png";